document.addEventListener('DOMContentLoaded', function () {
  const video = document.querySelector('.thumbs-block__card video');

  if (video) {
    let hasPlayed = false;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasPlayed) {
          // The video is played only once when it becomes visible
          setTimeout(() => {
            video.play();
            hasPlayed = true;
            observer.disconnect(); // Disable the observer so it doesn't track anymore
          }, 1000);
        }
      });
    }, {
      threshold: 0.7 // Video should be 70% visible on the screen
    });

    observer.observe(video);
  }
});
